import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { post, get } from "helpers/api_helper";
import { ZONE } from "helpers/url_helper";
import Select from "react-select";
import { showSuccessAlert, showErrorAlert } from "helpers/alert_helper";

const RateForm = ({cb = () => {}}) => {
    const [selectedCountry, setSelectedCountry] = useState(null);   
    const [countriesOptions, setCountriesOptions] = useState([]);
    const [citiesOptions, setCitiesOptions] = useState([]);
    const [statesOptions, setStatesOptions] = useState([]);   
    const [selectedStates, setSelectedStates] = useState([]);
    const [selectedCitiesVal, setSelectedCitiesVal] = useState([]);
    const [selectedCities, setSelectedCities] = useState([]); 
    const [formData, setFormData] = useState({
        title: '',
        pincode: ''
    });

    const inintailCall = async() => {
        const [locationResponse] = await Promise.all([
            get(`locations/all`),
        ]);

        if (locationResponse.success) {
            setCountriesOptions(locationResponse.data);
        }
    }

    useEffect(() => {
        inintailCall();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleCountryChange = async(e) => {
        if (!e) {
            setSelectedCountry(null);
            setStatesOptions([]);
            setCitiesOptions([]);
            setSelectedStates([]);
            setSelectedCitiesVal([]);
            setSelectedCities([]);
            return;
        }
        setSelectedCountry(e);
        setStatesOptions(e.states || []);
        setCitiesOptions([]);
        setSelectedStates([]);
        setSelectedCitiesVal([]);
        const p = [];
        const cities = [];
        if (e.states) {
            e.states.forEach(v => {
                if (v.cities) {
                    cities.push(...v.cities);
                    p.push(...v.cities.map(c => c.value));
                }
            });
        }
        setCitiesOptions(cities);
        setSelectedCities(p);
    }

    const handleStateChange = async(e) => {
        setSelectedStates(e || []);
        setSelectedCitiesVal([]);
        setCitiesOptions([]);
        const p = [];
        if (e && e.length) {
            const cities = [];
            e.forEach(v => {
                if (v.cities) {
                    cities.push(...v.cities);
                    p.push(...v.cities.map(c => c.value));
                }
            });
            setCitiesOptions(cities);
        } else {
            const cities = [];
            if (selectedCountry && selectedCountry.states) {
                selectedCountry.states.forEach(v => {
                    if (v.cities) {
                        cities.push(...v.cities);
                        p.push(...v.cities.map(c => c.value));
                    }
                });
            }
            setCitiesOptions(cities);
        }
        setSelectedCities(p);
    }

    const handlecityChange = (e) => {
        setSelectedCitiesVal(e || []);
        const p = [];
        if (e && e.length) {
            p.push(...e.map(v => v.value));
        } else {
            citiesOptions.forEach(v => {
                p.push(v.value);
            });
        }
        setSelectedCities(p);
    }
    
    const handelSubmit = async (e) => {
        e.preventDefault();
        
        try{
            // Create JSON payload
            const payload = {
                ...formData,
                pincode: selectedCities.join(','),
            };
            const { success } = await post(ZONE, payload);
            if(success){
                showSuccessAlert('Zone created successfully', () => {
                    setSelectedCountry(null);
                    setCountriesOptions([]);
                    setCitiesOptions([]);
                    setStatesOptions([]);
                    setSelectedStates([]);
                    setSelectedCitiesVal([]);
                    setSelectedCities([]);
                    setFormData({
                        title: '',
                        pincode: ''
                    });
                });
                cb();
            } 
        } catch (error) {
            showErrorAlert(error.message || 'Failed to create zone');
        }
    };

    return (
        <Row>
            <Col>
                <Card>
                    <CardBody>
                        <h5 className="mb-3"> <i onClick={cb} className="fas fa-arrow-left me-3" role="button" title="Back to All Zones" /> New Zone</h5>
                        <hr />
                        <form onSubmit={handelSubmit}>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label htmlFor="title">Zone Name</label>
                                        <input type="text" className="form-control" id="title" name="title" value={formData.title} onChange={handleInputChange} placeholder="Zone name" required />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={12}>
                                    <div className="form-group">
                                        <label htmlFor="country">Select Country</label>
                                        <Select
                                            value={selectedCountry}
                                            onChange={handleCountryChange}
                                            options={countriesOptions}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder="Select Country"
                                        />
                                    </div>
                                </Col>
                                <Col md={12} className="mt-2">
                                    <div className="form-group">
                                        <label htmlFor="states">Select States ({statesOptions?.length || 0})</label>
                                        <Select
                                            value={selectedStates}
                                            onChange={handleStateChange}
                                            options={statesOptions}
                                            isMulti={true}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder="Select States"
                                        />
                                    </div>
                                </Col>
                                <Col md={12} className="mt-2">
                                    <div className="form-group">
                                        <label htmlFor="cities">Select Cities ({citiesOptions?.length || 0})</label>
                                        <Select
                                            value={selectedCitiesVal}
                                            onChange={handlecityChange}
                                            options={citiesOptions}
                                            isMulti={true}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder="Select Cities"
                                        />
                                    </div>
                                </Col>
                            </Row>
                            
                            <hr />
                            <Row className="text-end">
                                <Col>
                                    <button className="btn btn-danger me-2" style={{width: '120px'}} type="button" onClick={cb}>Cancel</button>
                                    <button className="btn btn-primary" style={{width: '120px'}} type="submit">Submit</button>
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                    
                </Card>
            </Col>
        </Row>
    );
}

export default RateForm;